import { defineMessages } from 'react-intl'

export default defineMessages({
  feedbackPath: {
    id: 'containers.ProjectPage.paths.feedback',
    defaultMessage: 'feedback',
  },
  feedbackSubmittedPath: {
    id: 'containers.ProjectPage.paths.feedback.submitted',
    defaultMessage: 'feedback/submitted',
  },
  votePath: {
    id: 'containers.ProjectPage.paths.vote',
    defaultMessage: 'vote',
  },
  voteSubmittedPath: {
    id: 'containers.ProjectPage.paths.vote.submitted',
    defaultMessage: 'vote/submitted',
  },
  leadPath: {
    id: 'containers.ProjectPage.paths.lead',
    defaultMessage: 'get-free-quote',
  },
  leadSubmittedPath: {
    id: 'containers.ProjectPage.paths.lead.submitted',
    defaultMessage: 'get-free-quote/thanks',
  },
  quotePath: {
    id: 'containers.ProjectPage.paths.quote',
    defaultMessage: 'quote',
  },
  quoteSubmittedPath: {
    id: 'containers.ProjectPage.paths.quote.submitted',
    defaultMessage: 'quote/accepted',
  },
  metaTitle: {
    id: 'containers.ProjectPage.meta.title',
    defaultMessage: 'Shared Voices • VoiceArchive',
  },
  metaDescription: {
    id: 'containers.ProjectPage.meta.description',
    defaultMessage:
    'These voices were handpicked and shared, from the library of VoiceArchives 2100+ voice actors. Visit us at https://voicearchive.com to explore more.',
  },
  title: {
    id: 'containers.ProjectPage.title',
    defaultMessage: 'Your selected voices',
  },
  subtitle: {
    id: 'containers.ProjectPage.subtitle',
    defaultMessage:
      'Quality checked, vetted and always ready to record your next project.',
  },
  feedbackSubtitle: {
    id: 'containers.ProjectPage.feedback.subtitle',
    defaultMessage:
    'The following voices were shared with you, for your input. Please use the voting buttons to cast your vote on your preferred selection.',
  },
  voteTitle: {
    id: 'containers.ProjectPage.vote.title',
    defaultMessage: 'Cast your vote on the best voice',
  },
  voteSubtitle: {
    id: 'containers.ProjectPage.vote.subtitle',
    defaultMessage:
    'The following voices were shared with you, for your input. Please use the voting buttons to cast your vote on your preferred selection.',
  },
  voteSubmittedTitle: {
    id: 'containers.ProjectPage.vote.submitted.title',
    defaultMessage: 'Thank you!',
  },
  voteSubmittedSubtitle: {
    id: 'containers.ProjectPage.vote.submitted.subtitle',
    defaultMessage: 'Thank you!',
  },
  leadTitle: {
    id: 'containers.ProjectPage.lead.title',
    defaultMessage: 'Now, we just need a bit of information',
  },
  leadSubtitle: {
    id: 'containers.ProjectPage.lead.subtitle',
    defaultMessage:
    'Your voice selection is saved, and you can come back to this link anytime to proceed.',
  },
  leadSubmittedTitle: {
    id: 'containers.ProjectPage.lead.submitted.title',
    defaultMessage: 'Thank you, {name}!',
  },
  leadSubmittedSubtitle: {
    id: 'containers.ProjectPage.lead.submitted.subtitle',
    defaultMessage:
    'We will get back shortly with a quote and an estimated deadline.',
  },
  quoteTitle: {
    id: 'containers.ProjectPage.quote.title',
    defaultMessage: 'Now, we just need a bit of information',
  },
  quoteSubtitle: {
    id: 'containers.ProjectPage.quote.subtitle',
    defaultMessage:
    'Your voice selection is saved, and you can come back to this link anytime to proceed.',
  },
  quoteSubmittedTitle: {
    id: 'containers.ProjectPage.quote.submitted.title',
    defaultMessage: 'Thank you!',
  },
  quoteSubmittedSubtitle: {
    id: 'containers.ProjectPage.quote.submitted.subtitle',
    defaultMessage:
    'Your quote has now been accepted, and we are ready to start production. You will hear from you project manager soon.',
  },
  UNGROUPED: {
    id: 'containers.ProjectPage.characters.ungrouped',
    defaultMessage: 'No character',
  },
  loading: {
    id: 'containers.ProjectPage.loading',
    defaultMessage: 'Loading',
  },
  startProject: {
    id: 'containers.ProjectPage.buttons.startProject',
    defaultMessage: 'Get free quote',
  },
  editProject: {
    id: 'containers.ProjectPage.buttons.editProject',
    defaultMessage: 'Edit project',
  },
  voiceBook: {
    id: 'containers.ProjectPage.buttons.VoiceBook',
    defaultMessage: 'Voice Book™',
  },
  voiceBookHint: {
    id: 'containers.ProjectPage.buttons.VoiceBook.hint',
    defaultMessage: 'Get live custom demos and deadline confirmation',
  },
  openInPortal: {
    id: 'containers.ProjectPage.buttons.openInPortal',
    defaultMessage: 'Go to order',
  },
  missingServerOrVoiceToAcceptProject:{
      id: 'containers.ProjectPage.buttons.missingServerOrVoiceToAcceptProject',
      defaultMessage: "You must select at least one service or voice to accept quote"
  },
  acceptProject:{
    id:'containers.ProjectPage.buttons.acceptProject',
    defaultMessage:'Accept & Proceed'
  },
  showPreviousQuote:{
    id:'containers.ProjectPage.buttons.showPreviousQuote',
    defaultMessage:'Click here to show previous quote'
  },
  viewingProjectAsCoordinatorTitle: {
    id:'containers.ProjectPage.viewingProjectAsCoordinatorTitle',
    defaultMessage:'You are viewing this project in edit mode'
  },
  viewingProjectAsCoordinatorSubtitle:{
    id:'containers.ProjectPage.viewingProjectAsCoordinatorSubtitle',
    defaultMessage:'The client will see a contact form and CTAs here. Click "View" in the toolbar, to preview.'
  },
  editContractLead: {
    id: 'containers.ProjectPage.editContractLead',
    defaultMessage: "<p>Edit contact data, brief, etc. on behalf of client on lead <a>{leadId}</a> <externalLink></externalLink> in Bitrix24.</p>"
  },
  editContractDeal:{
      id: 'containers.ProjectPage.editContractDeal',
      defaultMessage: "<p>Edit contact data, brief, etc. on behalf of client on deal <a>{dealId}</a> <externalLink></externalLink> in Bitrix24.</p>"
  },
  genders: {
      id:'containers.ProjectPage.VTgendersFilterLabel',
      defaultMessage:'Genders'
  },
  languages: {
      id:'containers.ProjectPage.VTlanguagesFilterLabel',
      defaultMessage:'Languages'
  }

})
